module.exports = __webpack_public_path__ + "img/SS_V_Basic_Fire.8797d14f.png";